import { Component, OnInit, ViewChild } from '@angular/core';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from 'app/shared/models/User';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { Location } from '@angular/common';
import { AuditTemplateService } from 'app/audit-template/services/audit-template.service';
import { AuditCategoryModel } from '../../models/audit-category.model';
import { AuditTemplateDetailsModel } from '../../models/audit-template-details.model';

@Component({
  selector: 'app-audit-template-details',
  templateUrl: './audit-template-details.component.html',
  styleUrls: ['./audit-template-details.component.css']
})
export class AuditTemplateDetailsComponent implements OnInit {

    headerTitle: IHeaderTitle;
    errors: string[];
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;
    submitAttempt: boolean = false;
    auditTemplateDetailsFormGroup: FormGroup;
    auditTemplateDetailsModel: AuditTemplateDetailsModel;
    auditCategoryList: AuditCategoryModel[];
    auditTemplateId: string;
    isEditMode = false;
    categoryString: string;

    constructor(
        private auditTemplateService: AuditTemplateService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        private location: Location,
        private router: Router        
    ) { }

    ngOnInit() {

        this.auditTemplateId = this.activatedRoute.snapshot.params['id'];        

        this.auditTemplateService.get(this.auditTemplateId).subscribe(result => {
            this.auditTemplateDetailsModel = result;
            this.headerTitle = {
                title: result.description,
                breadcrumbs: [{ title: 'Audit Templates', url: ['/audit-template'] }]
            };
            this.auditTemplateService.getAuditCategories().subscribe(
                categories => {
                    this.auditCategoryList = categories;
                    this.categoryString = categories.filter(c => c.id === result.auditCategoryId)[0].description;
                    this.initializeForm(result);
                },
                error => {
                    this.errors = error.errorList;
                }
            );
        });
  }

    initializeForm(model: AuditTemplateDetailsModel): void {
        this.auditTemplateDetailsFormGroup = this.fb.group(
            {
                id: [this.auditTemplateId],
                description: [model.description],
                auditCategoryId: [model.auditCategoryId],
                isActive: [model.isActive],
                recurrence: [model.recurrence]
            }
        );
    }

    updateAuditTemplate(): void {
        this.submitAttempt = true;
        if (this.auditTemplateDetailsFormGroup.valid) {
            const formValue = this.auditTemplateDetailsFormGroup.value;
            this.auditTemplateService.update(formValue).subscribe(
                response => {
                    this.alertMessage.showMessage();
                },
                error => {
                    this.errors = error.errorList;
                }
            );
        }
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    successClicked($event: any): void {
        this.router.navigate(['./audit-template']);
    }

    onHide($event: any): void { }

    onBack($event: any): void {
        this.location.back();
    }

}
